.scopedSection {
  padding-bottom: 4px;
}

.reviewerSection {
  border-top: 1px solid var(--border);
  padding-top: 4px;
  margin-top: 4px;
}

.reviewerSectionHeader {
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding: 14px 0 4px;
}

.reviewerSectionLabel {
  font-size: 13px;
  font-weight: 600;
  color: var(--ink2);
  text-transform: uppercase;
  letter-spacing: .06em;
}

.reviewerSectionHint {
  font-size: 12.5px;
  color: var(--muted2);
}

.crosspostSection {
  border-top: 1px solid var(--border);
  padding-top: 4px;
  margin-top: 4px;
}
